export default "__VITE_ASSET__CPMF2G2d__"